export const SHEET_IDS = {
    DIALOG_SHARE: 'share',
    CHART_MENU: 'menu',
    DIALOG_ERROR: 'error-details',
    DIALOG_SCREENSHOT: 'download-screenshot',
    DIALOG_DASH_META: 'dash-meta',
    DIALOG_ENTRY_DESCRIPTION: 'entry-description',
};
